<section class="py-16 px-4 bg-white" [style.minHeight]="minHeight">
  <div class="max-w-5xl mx-auto text-center">

    <h2 class="text-2xl md:text-3xl font-bold text-[#001d4a] mb-10 relative inline-block">
      {{ sectionTitle }}
      <div class="mt-2 flex justify-center">
        <span class="w-20 h-1.5 bg-orange-400 rounded-full"></span>
      </div>
    </h2>

    <div class="relative group cursor-pointer overflow-hidden rounded-[2.5rem] shadow-2xl aspect-video bg-slate-200"
      [class.mb-10]="showButton">

      <img fill [ngSrc]="thumbnailUrl"
        class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105">

      @if (isVideo) {
      <div class="absolute inset-0 flex items-center justify-center bg-black/10 group-hover:bg-black/20 transition-all">
        <div
          class="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-2xl transform transition-all duration-300 group-hover:scale-110 group-hover:bg-orange-500 group-hover:text-white text-orange-500">
          <i class="fa-solid fa-play text-3xl ml-1"></i>
        </div>
      </div>
      }

      @if (videoLabel) {
      <div
        class="absolute bottom-6 left-8 text-left bg-black/40 backdrop-blur-md p-4 rounded-2xl border border-white/20">
        <p class="text-white/70 text-xs uppercase tracking-widest mb-1">Watch Now</p>
        <h3 class="text-white font-bold text-lg">{{ videoLabel }}</h3>
      </div>
      }
    </div>

    @if (showButton) {
    <div class="flex justify-center mt-8">
      <a [href]="buttonLink"
        class="inline-flex items-center gap-2 bg-[#001d4a] text-white px-10 py-4 rounded-full font-bold transition-all duration-300 hover:bg-orange-500 hover:shadow-xl hover:-translate-y-1">
        {{ buttonText }}
        <i class="fa-solid fa-arrow-right-long"></i>
      </a>
    </div>
    }

  </div>
</section>